module.exports = __webpack_public_path__ + "img/sleeve upper arm width.19bc96ab.png";